import React from "react";
import styles from "../App.css";
import { TypeAnimation } from "react-type-animation";
 
 
const VoipIntercom=()=>{  
  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>VoIP Intercom System</h1>
      <TypeAnimation
        sequence={[
          "A VoIP intercom system uses Voice over Internet Protocol (VoIP) technology to enable voice communication between devices, like phones or intercom stations, over an IP network, such as the internet, instead of traditional phone lines. It essentially allows you to make calls within a building, or across a network, using your internet connection rather than a regular phone line.",
          1000,
        ]}
        wrapper="p"
        speed={70}
        className={styles.description}
        repeat={1}
        transition={{ duration: -1 }}
      />
    </div>
  );
};

export default VoipIntercom;
